<template>
  <div>
    <v-form
      ref="templateForm"
      v-model="validTemplate"
      lazy-validation
    >
    <v-row>
      <v-col cols="6" sm="6" md="3">
        <v-text-field
          v-model="Template.Name"
          style="padding-top: 0;"
          :label="$t('templateName')" 
          solo
          required
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="6" md="3" style="text-align: initial;padding-bottom: 0;">
        <v-btn @click="saveTemplateConfirmation()" class="regularText" :color="colorTheme" dark style="height: 48px;">
          <v-icon class="icon-size pr-1">mdi-content-save</v-icon>{{ $t("save").toUpperCase() }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- REPORTES PERIÓDICOS -->
    <v-row>
      <v-col cols="12" sm="12" md="12" style="text-align: initial;padding-top: 0;">
        <v-icon
          :color="colorTheme"
          class="icon-size-subtitle pr-1"
        >mdi-clock-time-four-outline</v-icon>
        <span class="subtitle3Text">{{ $t("periodicReports").toUpperCase() }}</span>
      </v-col>
    </v-row>
    <!--nota para el modo obscuro-->
    <v-row
      style="border-color: azure;border: solid gray;border-width: 1.05px;margin: 10px 0px 10px 0px;background-color: white;"
    >
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-switch class="pr-1" style="display: inline-table;" v-model="Template.PeriodicReports.OdometerReport" :color="colorTheme"></v-switch>
        <span class="regularText">{{ $t("odometerReport") }}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span>Información pertinente del parametro</span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-switch class="pr-1" style="display: inline-table;" v-model="Template.PeriodicReports.FuelReport" :color="colorTheme"></v-switch>
        <span class="regularText">{{ $t("fuelReport") }}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span>Información pertinente del parametro</span>
        </v-tooltip>
      </v-col>
      <v-progress-linear color="#8E8E8E" height="1" value="100" width="50%"></v-progress-linear>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch
              class="pr-1"
              style="display: inline-table;"
              v-model="Template.PeriodicReports.VehicleStoppedReport.Active"
              :color="colorTheme"
            ></v-switch>
            <span class="regularText">{{ $t("stoppedVehicleReport") }}</span> 
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" style="padding-top: 0;">
            <v-text-field
              v-model="Template.PeriodicReports.VehicleStoppedReport.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch
              class="pr-1"
              style="display: inline-table;"
              v-model="Template.PeriodicReports.VehicleInMotionReport.Active"
              :color="colorTheme"
            ></v-switch>
            <span class="regularText">{{ $t("vehicleRunningReport") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" style="padding-top: 0;">
            <v-text-field
              v-model="Template.PeriodicReports.VehicleInMotionReport.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch
              class="pr-1"
              style="display: inline-table;"
              v-model="Template.PeriodicReports.TimeReport.Active"
              :color="colorTheme"
            ></v-switch>
            <span class="regularText">{{ $t("timeReport") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" style="padding-top: 0;">
            <v-text-field
              v-model="Template.PeriodicReports.TimeReport.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
    <!-- LOGÍSTICA -->
    <v-row>
      <v-col cols="12" sm="12" md="12" style="text-align: initial;">
        <v-icon class="icon-size-subtitle pr-1" :color="colorTheme">mdi-poll</v-icon>
        <span class="subtitle3Text">{{ $t("logistics").toUpperCase() }}</span>
      </v-col>
    </v-row>
    <!--nota para el modo obscuro-->
    <v-row
      style="border-color: azure;border: solid gray;border-width: 1.05px;margin: 10px 0px 10px 0px;background-color: white;"
    >
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("highIdlePercentage") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon  class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              style="width: 50%;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              v-model="Template.Logistics.HighIdlePercentage"
              type="number"
              min="0"
              max="100"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("alertExcessiveIdlingTime") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Logistics.ExcessIdleTime"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev456") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Logistics.InsufficientRestTime"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev464") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Logistics.RestDetected"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="65535"
              oninput="if(this.value > 65535) this.value = 65535;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- CONDUCCIÓN -->
    <v-row>
      <v-col cols="12" sm="12" md="12" style="text-align: initial;">
        <v-icon :color="colorTheme" style="padding-right: 5px;font-size: xx-large;">mdi-steering</v-icon>
        <span class="subtitle3Text">{{ $t("driving").toUpperCase() }}</span>
      </v-col>
    </v-row>
    <!--nota para el modo obscuro-->
    <v-row
      style="border-color: azure;border: solid gray;border-width: 1.05px;margin: 10px 0px 10px 0px;background-color: white;"
    >
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch style="display: inline-table;" v-model="Template.Driving.RPMExcess.Active" :color="colorTheme"></v-switch>
            <span class="regularText">{{ $t("ExcessRpmCounter") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.RPMExcess.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="5000"
              oninput="if(this.value > 5000) this.value = 5000;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">Rpms</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("quickPowerOff") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.QuickShutdown"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev447") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" >
            <v-text-field
              v-model="Template.Driving.ClutchTimeExcessWhileDriving"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev448") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.ClutchTimeExcessStopped"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev449") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.ExcessBrakeTime"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev452") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.SuddenAcceleration"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ SelectedDistance }}/h-s</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev453") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.SuddenBraking"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ SelectedDistance }}/h-s</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev457") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.MediumSpeeding"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ SelectedDistance }}/h</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev458") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Driving.SevereSpeeding"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ SelectedDistance }}/h</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- OPERACIÓN DEL VEHÍCULO -->
    <v-row>
      <v-col cols="12" sm="12" md="12" style="text-align: initial;">
        <v-icon :color="colorTheme" style="padding-right: 5px;font-size: xx-large;">mdi-car-info</v-icon>OPERACIÓN DEL VEHÍCULO
      </v-col>
    </v-row>
    <v-row
      style="border-color: azure;border: solid gray;border-width: 1.05px;margin: 10px 0px 10px 0px;background-color: white;"
    >
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch style="display: inline-table;" v-model="Template.Operation.MotorLoadExcess.Active" :color="colorTheme"></v-switch>
            <span class="regularText">{{ $t("ev450") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" style="padding-top: 0;">
            <v-text-field
              v-model="Template.Operation.MotorLoadExcess.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="100"
              oninput="if(this.value > 100) this.value = 100;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev454") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Operation.LowCruiseControlPercentage"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="100"
              oninput="if(this.value > 100) this.value = 100;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev459") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Operation.LowFuelEconomy"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="255"
              oninput="if(this.value > 255) this.value = 255;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ SelectedDistance }}/{{ SelectedVolume }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        style="text-align: initial;padding-top: 0;padding-bottom: 0;"
      >
        <v-row>
          <v-col cols="12" style="padding-top: 0;padding-bottom: 0;">
            <v-switch style="display: inline-table;" v-model="Template.Operation.PTOStopped.Active" :color="colorTheme"></v-switch>
            <span class="regularText">{{ $t("ev463") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" style="padding-top: 0;">
            <v-text-field
              v-model="Template.Operation.PTOStopped.Threshold"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev466") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Operation.HighAverageMotorLoad"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="100"
              oninput="if(this.value > 100) this.value = 100;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev479") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Operation.StartOfPTOInMotion"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" style="text-align: initial;padding-bottom: 0;">
        <v-row>
          <v-col cols="12">
            <span class="regularText">{{ $t("ev480") }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-size pl-1" color="#8E8E8E" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Información pertinente del parametro</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="Template.Operation.EndOfPTOInMotion"
              style="width: 50%;margin: 0;padding-top: 0px;display: inline-block;padding-right: 15px;"
              :label="$t('threshold')"
              solo
              type="number"
              min="0"
              max="268435455"
              oninput="if(this.value > 268435455) this.value = 268435455;"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <span class="regularText">{{ $t("seconds") }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    </v-form>
    
    <v-dialog v-model="confirmSaveTemplate" persistent max-width="500">
      <v-card>
        <v-card-title class="subtitle3Text">{{ $t("confirmationT") }}</v-card-title>
        <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
        <v-card-text class="regularText" style="color:black;">{{ confirmSaveTemplateText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            :color="colorTheme"
            text
            @click="confirmSaveTemplate = false"
            class="regularText"
          >{{ $t("cancel").toUpperCase() }}</v-btn>

          <v-btn :color="colorTheme" text @click="saveTemplateConfirmed()" class="regularText">{{ $t("accept").toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "newTemplate",
  data: () => ({
    confirmSaveTemplate: false,
    confirmSaveTemplateText: "",
    validTemplate: true,
    rules: {
      required: value => !!value || i18n.t("requiredData"),
    }
  }),
  created() {},
  mounted() {},

  computed: {
    ...mapState([
      "colorTheme",
      "Template",
      "valueDeterminate",
      "SelectedDistance",
      "SelectedVolume"
    ])
  },
  methods: {
    saveTemplateConfirmation() {
      if (this.$refs.templateForm.validate()) {

        let dialogTitleForSaving = "";
        if (this.$store.state.PageHeaderSub == i18n.t("newTemplate").toUpperCase()) {
          dialogTitleForSaving = i18n.t("saveTemplate");
          dialogTitleForSaving = dialogTitleForSaving.replace("__TEMPLATENAME__", this.Template.Name);

        } else {
          dialogTitleForSaving = i18n.t("saveTemplateChanges");
          dialogTitleForSaving = dialogTitleForSaving.replace("__TEMPLATENAME__", this.Template.Name);
        }

        this.confirmSaveTemplateText = dialogTitleForSaving;
        this.confirmSaveTemplate = true;

      } else {

        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("verifyConfig")
        });
      }
    },

    saveTemplateConfirmed() {
      this.$store.commit("setPageHeader", [
        this.$t("configTemplates").toUpperCase(),
        "",
        "",
        "",
        true
      ]);
      this.$store.commit("showTemplates", true);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>










